import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import experiences from '../../data/experiences';
import projects from '../../data/projects';
import styles from './DetailNav.module.css';

// One flat ordering across experiences then projects, so prev/next walks the
// whole site the same way the home page presents it.
const entries = [
  ...experiences
    .filter((e) => !e.external)
    .map((e) => ({ route: e.route, primary: e.org, secondary: e.role })),
  ...projects.map((p) => ({ route: p.route, primary: p.title, secondary: p.event || String(p.year) })),
  // WATonomous has two timeline entries pointing at one page; keep one stop.
].filter((e, i, all) => all.findIndex((x) => x.route === e.route) === i);

/**
 * Rendered from Layout for every route except home.
 *   place="top"    -> back link above the page content
 *   place="bottom" -> prev/next pager below it
 * Keeps a recruiter moving instead of dead-ending on a detail page.
 */
export default function DetailNav({ place = 'top' }) {
  const { pathname } = useLocation();
  const idx = entries.findIndex((e) => e.route.toLowerCase() === pathname.toLowerCase());

  const prev = idx > 0 ? entries[idx - 1] : null;
  const next = idx !== -1 && idx < entries.length - 1 ? entries[idx + 1] : null;

  if (place === 'top') {
    return (
      <nav className={`${styles.wrap} mc-shell`} aria-label="Back">
        <Link to="/" className={styles.back}>
          <span aria-hidden="true">←</span> All work
        </Link>
      </nav>
    );
  }

  if (!prev && !next) return null;

  return (
    <nav className={`${styles.wrap} ${styles.wrapBottom} mc-shell`} aria-label="Previous and next">
      {(prev || next) && (
        <div className={styles.pager}>
          {prev && (
            <Link to={prev.route} className={styles.pageLink}>
              <span className="mc-eyebrow">Previous</span>
              <span className={styles.pageTitle}>{prev.primary}</span>
              <span className={styles.pageSub}>{prev.secondary}</span>
            </Link>
          )}
          {next && (
            <Link to={next.route} className={`${styles.pageLink} ${styles.pageNext}`}>
              <span className="mc-eyebrow">Next</span>
              <span className={styles.pageTitle}>{next.primary}</span>
              <span className={styles.pageSub}>{next.secondary}</span>
            </Link>
          )}
        </div>
      )}
    </nav>
  );
}
